import { Nav } from "@/components/prometheus/Nav";
import { Hero } from "@/components/prometheus/Hero";
import { Disciplines } from "@/components/prometheus/Disciplines";
import { Labs } from "@/components/prometheus/Labs";
import { ScientificSimulations } from "@/components/prometheus/ScientificSimulations";
import { Method } from "@/components/prometheus/Method";
import { CTA } from "@/components/prometheus/CTA";
import { Footer } from "@/components/prometheus/Footer";
import { useEffect } from "react";

const Index = () => {
  useEffect(() => {
    document.title = "Prometheus Lab AI — Roba el fuego, devuélvelo al mundo";
    try {
      const desc = "Escuela-taller donde ingeniería, ciencia, oficios e impresión 3D se funden con el método de las grandes mentes para inventar y reinventar.";
      const metaTag = document.querySelector('meta[name="description"]');
      if (metaTag) {
        metaTag.setAttribute("content", desc);
      } else {
        const newMeta = document.createElement("meta");
        newMeta.setAttribute("name", "description");
        newMeta.setAttribute("content", desc);
        document.head.appendChild(newMeta);
      }
    } catch (e) {}
  }, []);

  return (
    <main className="min-h-screen bg-background text-foreground">
      <Nav />
      <Hero />
      <Disciplines />
      <Labs />
      <ScientificSimulations />
      <Method />
      <CTA />
      <Footer />
    </main>
  );
};

export default Index;
